import { isRecord } from "../Editor/utils/typePredicates";

export interface BoxModelValues {
  [key: string]: string | number;
}

export interface ResponsiveValue {
  desktop: unknown;
  mobile: unknown;
  tablet: unknown;
}

const RESPONSIVE_SIZE_SIZES = ["desktop", "tablet", "mobile"];

const isValidResponsiveValue = (value: unknown): boolean => {
  if (
    typeof value === "string" ||
    typeof value === "number" ||
    value === null
  ) {
    return true;
  }

  if (isRecord(value)) {
    return Object.values(value).every(
      val => typeof val === "string" || typeof val === "number" || val === null,
    );
  }

  return false;
};

export const isResponsiveValue = (value: unknown): value is ResponsiveValue => {
  if (!isRecord(value)) {
    return false;
  }

  const keys = Object.keys(value);

  return (
    keys.length === 3 &&
    keys.every(key => RESPONSIVE_SIZE_SIZES.includes(key)) &&
    keys.every(key => isValidResponsiveValue(value[key]))
  );
};
